import { render, staticRenderFns } from "./pay-record.vue?vue&type=template&id=70747c3e&scoped=true&"
import script from "./pay-record.vue?vue&type=script&lang=js&"
export * from "./pay-record.vue?vue&type=script&lang=js&"
import style0 from "./pay-record.vue?vue&type=style&index=0&id=70747c3e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70747c3e",
  null
  
)

export default component.exports